import { render, staticRenderFns } from "./RejectPendingLead.vue?vue&type=template&id=2d2bb274&scoped=true"
import script from "./RejectPendingLead.vue?vue&type=script&lang=js"
export * from "./RejectPendingLead.vue?vue&type=script&lang=js"
import style0 from "./RejectPendingLead.vue?vue&type=style&index=0&id=2d2bb274&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2bb274",
  null
  
)

export default component.exports